// src/pages/script-builder/ScriptBuilder.js
import React, { useState } from 'react';

/** Example mock data (replace with real data from API if needed) */
const initialScripts = [
    {
        id: 1,
        scriptName: 'Welcome Script',
        status: 'Active',
        campaignName: 'New Users',
        dateCreated: '2023-10-01',
        createdBy: 'SLAI AI',
        lastModifiedDate: '2023-10-05',
    },
    {
        id: 2,
        scriptName: 'Reminder Script',
        status: 'Inactive',
        campaignName: 'Retention',
        dateCreated: '2023-09-20',
        createdBy: 'User',
        lastModifiedDate: '2023-09-25',
    },
    {
        id: 3,
        scriptName: 'Survey Script',
        status: 'Active',
        campaignName: 'Feedback',
        dateCreated: '2023-08-15',
        createdBy: 'SLAI AI',
        lastModifiedDate: '2023-08-20',
    },
];

const ScriptBuilder = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [scripts] = useState(initialScripts);

    /** Filter scripts by name or campaign name */
    const filteredScripts = scripts.filter(
        (script) =>
            script.scriptName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            script.campaignName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="script-builder-container">
            {/* Page Title (optional, can also rely on your existing <TopBar /> title) */}
            <h1 className="script-builder-title">Script Creation Studio</h1>

            {/* AI Script Creation Section */}
            <div className="ai-script-creation">
                <h2>SLAI's AI Script Creation</h2>
                <div className="ai-script-buttons">
                    <button className="btn generate-btn">Generate AI Script</button>
                    <button className="btn upload-btn">Upload Script</button>
                </div>
            </div>

            {/* Script Library Section */}
            <div className="script-library">
                <h3>Script Library</h3>
                <div className="library-header">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search by name or campaign"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <table className="script-table">
                    <thead>
                    <tr>
                        <th>Script Name</th>
                        <th>Status</th>
                        <th>Campaign Name</th>
                        <th>Date Created</th>
                        <th>Created By</th>
                        <th>Last Modified Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredScripts.length === 0 ? (
                        <tr>
                            <td colSpan="6" style={{ textAlign: 'center' }}>
                                No scripts found.
                            </td>
                        </tr>
                    ) : (
                        filteredScripts.map((script) => (
                            <tr key={script.id}>
                                <td>{script.scriptName}</td>
                                <td>
                                    {script.status === 'Active' ? (
                                        <span className="status-badge active-badge">Active</span>
                                    ) : (
                                        <span className="status-badge inactive-badge">Inactive</span>
                                    )}
                                </td>
                                <td>{script.campaignName}</td>
                                <td>{script.dateCreated}</td>
                                <td>{script.createdBy}</td>
                                <td>{script.lastModifiedDate}</td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ScriptBuilder;
